import {
  ViewMode,
} from "@nebula.gl/edit-modes";
import { getTooltips } from "../functions/getTooltips";

export class AthenaViewMode extends ViewMode {
  getTooltips = getTooltips
}